<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-23 20:41:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/product/detail/components/ShopInfo/index.vue
-->
<template>
  <!--品牌馆  -->
  <div class="con clearfix" @click="goBrand">
    <img
      v-if="mallretailspu.brand && mallretailspu.brand !== null"
      :src="mallretailspu.brand.logoImg"
      alt=""
      class="left left_icon"
    />
    <div
      v-if="mallretailspu.brand && mallretailspu.brand !== null"
      class="left name text_left"
    >
      <div class="font14 font_weight500 colo0 line_height_16">
        {{ mallretailspu.brand.name }}
      </div>
      <div class="font10 font_weight400 colo038 line_height_14 name_det">
        {{ mallretailspu.brand.resume }}
      </div>
    </div>
    <img
      src="@/assets/common/icon_back_b87_24@2x.png"
      alt=""
      class="right color_right"
    />
    <!-- <div
      v-if="mallretailspu.brand && mallretailspu.brand.count"
      class="font10 font_weight400 colo038 right shop_num"
    >
      {{ mallretailspu.brand.count }}件商品
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    mallretailspu() {
      return this.$store.getters.mallretailspu;
    }
  },
  methods: {
    goBrand() {
      this.$emit("goBrand");
    }
  }
};
</script>
<style lang="less" scoped>
.con {
  margin-top: 10px;
  background: #fff;
  padding: 14px 10px;
  border-radius: 6px;
  .name {
    max-width: 70%;
    line-height: 17px;
    margin: 6px 0 0 18px;
    .name_det {
      margin-top: 6px;
    }
  }
  .left_icon {
    border-radius: 6px;
    width: 48px;
    height: 48px;
  }
  .color_right {
    margin-top: 12px;
    width: 24px;
  }
  .shop_num {
    margin-top: 16px;
  }
}
</style>
